/* istanbul ignore file */
/* tslint:disable */
 

/**
 * * `d15` - 15 zile
 * * `m1` - o lună
 * * `m2` - 2 luni
 * * `m3` - 3 luni
 * * `m4` - 4 luni
 * * `m5` - 5 luni
 * * `m6` - 6 luni
 * * `m7` - 7 luni
 * * `m8` - 8 luni
 * * `m9` - 9 luni
 * * `m10` - 10 luni
 * * `m11` - 11 luni
 * * `m12` - 12 luni
 */
export enum InsuranceTerm {
  D15 = 'd15',
  M1 = 'm1',
  M2 = 'm2',
  M3 = 'm3',
  M4 = 'm4',
  M5 = 'm5',
  M6 = 'm6',
  M7 = 'm7',
  M8 = 'm8',
  M9 = 'm9',
  M10 = 'm10',
  M11 = 'm11',
  M12 = 'm12',
}
